import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import {
  Box,
  Grid,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  TablePagination,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/system";
import { Link, useNavigate } from "react-router-dom";
import apiClient from "../utlis/apiClient";
import Pagination from "../utlis/Pagination";
import TocIcon from "@mui/icons-material/Toc";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import PaginationComponent from "../Common/PaginationComponent";

const ManageWorkOrder = () => {
  const [workOrder, setWorkOrder] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await apiClient.get(
          `/api/in-out-source/Get-All-OutSources`
        );
        console.log(response.data); // Log the response to check its structure

        if (response) {
          setWorkOrder(response.data || []);
        } else {
          console.error("Failed to fetch work orders: ", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching work orders: ", error);
      } finally {
        setLoading(false); // Set loading to false when fetch completes
      }
    };

    fetchData();
  }, []); // Adding an empty dependency array ensures this runs once after the initial render

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#325c67",
      color: theme.palette.common.white,
      padding: "10px",
      verticalAlign: "top",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      padding: "10px !important",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#f3f3f3",
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };


 const handleClick = (workOrder) => {
   console.log("Navigating to UpdateWorkOrder with PK:", workOrder.PK);
   navigate("/UpdateWorkOrder", {
     state: {
       OutSourcePK: workOrder.PK,
     },
   });
 };

 const handleDelete = async (workOrder) => {
  setLoading(true);
  const updateDelete = {
    tableName: "In-Out-Source",
    pk: workOrder.PK,
    sk: workOrder.SK,
  };

  if (window.confirm(`Are you sure you want to delete this GatePass?`)) {
    try {
      const response = await apiClient.post("/api/remove", updateDelete);
      console.log(response.data);

      // Optionally, refresh tenders after deletion
      setWorkOrder((prevWorkOrder) =>
      prevWorkOrder.filter((item) => item.PK !== workOrder.PK)
      );
    } catch (error) {
      console.error("Error deleting tender:", error);
    } finally {
      setLoading(false); 
    }
  }
};



// const handleChangeRowsPerPage = (event) => {
//   setRowsPerPage(parseInt(event.target.value, 10));
//   setPage(0);
// };

const handleChangePage = (event, newPage) => {
  setPage(newPage);
};


  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Header />
      <SubHeader />
      <Grid
        container
        sx={{ flexGrow: 1, marginTop: "-80px", padding: 0 }}
        spacing={6}
      >
        <Grid item xs={12} md={9}>
          <Box
            sx={{
              minHeight: "calc(100vh - 112px)",
              backgroundColor: "white",
              padding: 2,
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              marginLeft: "150px",
              width: "1100px",
            }}
          >
            <Grid
              container
              alignItems="center"
              spacing={2}
              justifyContent="space-between"
            >
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  Work Order Details
                </Typography>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  sx={{ width: "50px" }}
                  component={Link}
                  to="/AddWorkOrder"
                >
                  Add
                </Button>
              </Grid>
            </Grid>

            <TableContainer component={Paper} sx={{ marginTop: 4 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>SNO</StyledTableCell>
                    <StyledTableCell>Gate Pass</StyledTableCell>
                    <StyledTableCell>Vendor Name</StyledTableCell>
                    <StyledTableCell>Customer Name</StyledTableCell>
                    <StyledTableCell>Issued Date</StyledTableCell>
                    <StyledTableCell>Received Date</StyledTableCell>
                    <StyledTableCell>Return Status</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Action</StyledTableCell>
                    <StyledTableCell>Delete</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={13} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : workOrder.length > 0 ? (
                    workOrder
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((workOrderItem, index) => (
                      <StyledTableRow key={workOrderItem.PK}>
                        <StyledTableCell>
                        {page * rowsPerPage + index + 1}
                        </StyledTableCell>
                        <StyledTableCell>
                          {workOrderItem.GatePass}
                        </StyledTableCell>
                        <StyledTableCell>
                          {workOrderItem.VendorName}
                        </StyledTableCell>
                        <StyledTableCell>
                          {workOrderItem.CustomerName}
                        </StyledTableCell>
                        <StyledTableCell>{workOrderItem.Issued_Date}</StyledTableCell>
                        <StyledTableCell>{workOrderItem.Received_Date}</StyledTableCell>
                        <StyledTableCell>
                          {workOrderItem.ReturnStatus}
                        </StyledTableCell>
                        <StyledTableCell>
                          {workOrderItem.Status}
                        </StyledTableCell>
                        <StyledTableCell>
                          <TocIcon
                            sx={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent parent element interference
                              handleClick(workOrderItem);
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <DeleteSweepIcon
                            onClick={() => handleDelete(workOrderItem)}
                            style={{ cursor: "pointer" }}
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={13} align="center">
                        No work orders available.
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
              <PaginationComponent count={workOrder.length} page={page} rowsPerPage={rowsPerPage} onPageChange={handleChangePage}  />
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ManageWorkOrder;
